<template>
  <div class="solution-list-container">
      <div class="solution-list footer" ref="activity_scroll" @scroll="activityScroll">
        <div class="list">
          <div class="item" v-for="(item,index) in solutionList" :key="index" @click="goIntro(item)">
            <div class="left-img">
              <!--            <van-image class="cover" src="http://cdn.juplus.cn/FnpC6aSNCabTnR4X-GlKgBVsEd_3"/>-->
              <img class="cover" :src="cdnUrl+item.cover_img_url" alt="">
            </div>
            <div class="right-content">
              <div class="title van-multi-ellipsis--l3">{{item.title}}</div>
              <div class="more">
                <button class="look-btn">查看内容</button>
              </div>
            </div>
          </div>
        </div>
        <div class="no-data" v-if="solutionList.length == 0">
          <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">
          <p class="hint-text">暂无数据</p>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        solutionList: {
          type: Array,
          default: []
        }
    },
    data () {
        return {
            // solutionList: []
            cdnUrl: this.$config.baseUrl.cdnUrl
        }
    },
    created () {
      console.log('组件中的数据',this.solutionList);
    },
    methods: {
      activityScroll () {

      },
      goIntro (item) {
        console.log('跳转详情');
        this.$router.push({
            name: 'solutionDetails',
            query: {
                id: item.id || ''
            }
        })
      }
    }
}
</script>

<style lang="scss" scoped>
.solution-list-container{
  // padding-top: rem(46);
  background: #F5F3F9;
  height: 100vh;
  .solution-list{
    border-top: 1px solid #E2E2E2;
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .list{
      .item{
        height: rem(105);
        margin-top: rem(20);
        display: flex;
        padding: 0 rem(20);
        &:last-child{
          margin-bottom: rem(20);
        }
        .left-img{
          width: rem(160);
          height: 100%;
          border-radius: 4px;
          .cover{
            width: 100%;
            height: 100%;
            border-radius: 4px;
          }
        }
        .right-content{
          flex: 1;
          padding: 0 rem(12);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title{
            color: #2C2C2C;
            font-size: rem(13);
            font-weight: bold;
          }
          .more{
            text-align: right;
            .look-btn{
              background: $base-color;
              border-radius:4px;
              color: #fff;
              outline: none;
              border: none;
              padding: rem(7) rem(9);
              font-size: 12px;
            }
          }
        }
      }
    }
    .no-data{
      width: 60%;
      display: block;
      margin: 0 auto;
      margin-top: rem(35);
      text-align: center;
      color: #b1acac;
      font-size: rem(13);
      padding-bottom: rem(10);
      .hint-text{
        margin: rem(10) 0;
      }
    }
  }
}
</style>